import { render, staticRenderFns } from "./EditLaboratoryServiceModal.vue?vue&type=template&id=4f7feb70&scoped=true"
import script from "./EditLaboratoryServiceModal.vue?vue&type=script&lang=js"
export * from "./EditLaboratoryServiceModal.vue?vue&type=script&lang=js"
import style0 from "./EditLaboratoryServiceModal.vue?vue&type=style&index=0&id=4f7feb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7feb70",
  null
  
)

export default component.exports